import axios from '@/utils/api'
import modulo from '@/utils/modulo'

const actions = {
  async byNumero ({ commit }) {
    return axios({ method: 'get', url: `${modulo.PUBLICO}/perguntasFrequentes` })
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/portal/publico/perguntaFrequente.js